module.exports = __webpack_public_path__ + "img/logo-dark.ac005489.png";